import { withCountryPrefix, withQuery } from "../components/utils/routeHelpers";

const LAST_SHOPPING_LIST_ID_KEY = "incooking_last_shopping_list_id";
const LAST_SHOPPING_IS_GUEST_KEY = "incooking_last_shopping_is_guest";

export function persistLastShoppingEntry({ listId, isGuest }) {
  if (typeof window === "undefined" || !window.localStorage || !listId) return;

  window.localStorage.setItem(LAST_SHOPPING_LIST_ID_KEY, String(listId));
  window.localStorage.setItem(LAST_SHOPPING_IS_GUEST_KEY, isGuest ? "1" : "0");
}

export function getLastShoppingEntryPath(country, { isAuthenticated = false } = {}) {
  if (typeof window === "undefined" || !window.localStorage) return null;

  const listId = window.localStorage.getItem(LAST_SHOPPING_LIST_ID_KEY);
  const isGuest = window.localStorage.getItem(LAST_SHOPPING_IS_GUEST_KEY) === "1";

  if (!listId) return null;
  if (!isGuest && !isAuthenticated) return null;

  const basePath = withCountryPrefix("/client/shopping/list", country);

  if (isGuest) {
    return withQuery(basePath, { guest: 1, list_id: listId });
  }

  return withQuery(basePath, { list_id: listId });
}

export function clearLastShoppingEntry() {
  if (typeof window === "undefined" || !window.localStorage) return;

  window.localStorage.removeItem(LAST_SHOPPING_LIST_ID_KEY);
  window.localStorage.removeItem(LAST_SHOPPING_IS_GUEST_KEY);
}
